// Centralized list of additional keywords a user might type when looking for a symbol.
// Keys should match the symbol alias; values are arrays of alternative names.
const SYMBOL_SYNONYMS = {
  'relevador-de-carga': ['relay', 'relevador de cargas', 'relé de carga', 'overload relay'],
  'ansi-relevador-de-sobrecarga': ['relay', 'relevador de protección', 'overload relay'],
  'iec-relevador-de-sobrecarga': ['relay', 'relevador de protección', 'overload relay'],
  'switch': ['seccionador', 'desconectador', 'knife switch', "cuchilla"],
  'interruptor-mtat-a': ['breaker', 'interruptor de potencia', 'power breaker'],
  'interruptor-mtat-b': ['breaker', 'interruptor de potencia', 'power breaker'],
  'ansi-interruptor-termomagnético-a': ['interruptor termomagnetico', 'breaker', 'thermomagnetic breaker'],
  'banco-de-capacitadores': ['capacitor bank', 'banco de capacitores', 'capacitores'],
  'filtro-de-armonicos-a': ['filtro armonico', 'harmonic filter', 'filter bank'],
  'filtro-de-armonicos-b': ['filtro armonico', 'harmonic filter', 'filter bank'],
  'reactor-a-tierra': ['reactor', 'reactor de puesta a tierra', 'grounding reactor'],
  'variador-de-frecuencia': ['variador', 'vfd', 'drive', 'variador de velocidad'],
  'ups': ['no-break', 'nobreak', 'sai', 'regulador de voltaje'],
  'transformador-con-dos-desvenados': ['transformador', 'transformador de dos devanados', 'two winding transformer'],
  'transformador-alumbrado-publico': ['transformador', 'transformador de alumbrado', 'lighting transformer'],
  'transformador-trifasico': ['transformador', 'transformador trifasico', 'three phase transformer'],
  'motor-de-inducción-a': ['motor', 'motor de induccion', 'induction motor'],
  'motor-de-inducción-b': ['motor', 'motor de induccion', 'induction motor'],
  'motor-sincrono': ['motor sincrono', 'synchronous motor'],
  'cargas-no-motor': ['carga', 'non motor load', 'load'],
  'cargas-no-motor-B': ['cargador de baterias', 'battery charger'],
  'contactos-trifasicos': ['contactos', 'tomacorriente trifasico', 'three phase receptacle'],
};

export default SYMBOL_SYNONYMS;
